import React from "react";
import TreydorexAccessSection from "../treydorex/TreydorexAccessSection";

/** Home `#sales` — Treydorex access + purchase (layout in TreydorexAccessSection). */
const Sales = () => <TreydorexAccessSection />;

export default Sales;
